import { faSmile } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Link from 'next/link';
import React, { useCallback, useState } from 'react';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { IContactForm, useContentContext } from 'src/Context/ContactContext';
import axios from 'axios';
import TextField from '../../atoms/Controls/TextField';

export const SContactForm = yup.object().shape({
    firstName: yup.string().required(),
    lastName: yup.string().required(),
    company: yup.string(),
    message: yup.string().required(),
    email: yup.string().required().email(),
});

const ContactForm: React.FC = () => {
    const [context] = useContentContext();

    const [privacyChecked, setPrivacyChecked] = useState(false);
    const [sentAttempt, setSentAttempt] = useState(false);
    const [submitted, setSubmitted] = useState(false);

    const submit = useCallback(async () => {
        setSentAttempt(true);

        if (!privacyChecked) {
            toast.error('You must accept the privacy policy beforehand.');
        } else if (await SContactForm.isValid(context)) {
            setSubmitted(true);

            await axios
                .post<IContactForm>('/api/contact/send', {
                    ...context,
                })
                .then((res) => {
                    // eslint-disable-next-line no-console
                    console.log(res);
                    toast.success('Thank you for your message!', { autoClose: 4000 });
                })
                .catch(() => {
                    toast.error('Error sending the message.', { autoClose: 4000 });
                });
        } else {
            toast.error('Please check again the data in the form', { autoClose: 4000 });
        }
    }, [context, privacyChecked]);

    return (
        <>
            <div className="max-w-7xl overflow-hidden py-16 px-4 sm:px-6 lg:px-8 lg:py-24">
                <div className="relative mx-auto max-w-xl">
                    <svg
                        className="absolute left-full translate-x-1/2 transform"
                        width="404"
                        height="404"
                        fill="none"
                        viewBox="0 0 404 404"
                        aria-hidden="true"
                    >
                        <defs>
                            <pattern
                                id="85737c0e-0916-41d7-917f-596dc7edfa27"
                                x="0"
                                y="0"
                                width="20"
                                height="20"
                                patternUnits="userSpaceOnUse"
                            >
                                <rect
                                    x="0"
                                    y="0"
                                    width="4"
                                    height="4"
                                    className="text-gray-200"
                                    fill="currentColor"
                                />
                            </pattern>
                        </defs>
                        <rect
                            width="404"
                            height="404"
                            fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)"
                        />
                    </svg>
                    <svg
                        className="absolute right-full bottom-0 -translate-x-1/2 transform"
                        width="404"
                        height="404"
                        fill="none"
                        viewBox="0 0 404 404"
                        aria-hidden="true"
                    >
                        <defs>
                            <pattern
                                id="85737c0e-0916-41d7-917f-596dc7edfa27"
                                x="0"
                                y="0"
                                width="20"
                                height="20"
                                patternUnits="userSpaceOnUse"
                            >
                                <rect
                                    x="0"
                                    y="0"
                                    width="4"
                                    height="4"
                                    className="text-gray-200"
                                    fill="currentColor"
                                />
                            </pattern>
                        </defs>
                        <rect
                            width="404"
                            height="404"
                            fill="url(#85737c0e-0916-41d7-917f-596dc7edfa27)"
                        />
                    </svg>

                    {submitted && (
                        <>
                            <div className="relative flex flex-col items-center justify-center">
                                <h2 className="font-serif text-3xl text-green-500 sm:text-4xl">
                                    <span className="block">Thanks for your message</span>
                                    <span className="mt-6 block text-secondary">
                                        I will get back to you as soon as I can.
                                    </span>
                                </h2>
                            </div>
                        </>
                    )}

                    {!submitted && (
                        <>
                            <div className="text-center">
                                <h2 className="font-serif text-3xl text-primary  text-gray-900 sm:text-4xl">
                                    Get in touch
                                </h2>
                                <p className="mt-4 text-lg leading-6 text-gray-500">
                                    You are interested in the topics on this blog or you need you
                                    need support to implement these topics yourself? Feel free to
                                    contact me at you can leave me a message, I will get back to
                                    you. you back.
                                    <br />
                                    <br />
                                    Your data will be used by the way for nothing else, that I
                                    promise you.
                                </p>
                            </div>

                            <div className="mt-12">
                                <div className="grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8">
                                    <div>
                                        <TextField
                                            name="firstName"
                                            label="Firstname"
                                            required
                                            sentAttempt={sentAttempt}
                                        />
                                    </div>
                                    <div>
                                        <TextField
                                            name="lastName"
                                            label="Lastname"
                                            required
                                            sentAttempt={sentAttempt}
                                        />
                                    </div>
                                    <div className="sm:col-span-2">
                                        <TextField
                                            name="company"
                                            label="Company"
                                            required={false}
                                            sentAttempt={sentAttempt}
                                        />

                                        <div className="block h-6" />

                                        <TextField
                                            name="email"
                                            label="eMail"
                                            required
                                            email
                                            sentAttempt={sentAttempt}
                                        />
                                    </div>
                                    <div className="sm:col-span-2">
                                        <TextField
                                            name="message"
                                            label="What is your concern? What do you want to talk to me about?"
                                            required
                                            type="textarea"
                                            sentAttempt={sentAttempt}
                                        />
                                    </div>
                                    <div className="sm:col-span-2">
                                        <div className="flex items-start">
                                            <div className="flex-shrink-0">
                                                <button
                                                    type="button"
                                                    className={`${
                                                        !privacyChecked
                                                            ? 'bg-gray-200'
                                                            : 'bg-primary'
                                                    } relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2`}
                                                    role="switch"
                                                    aria-checked="true"
                                                    onClick={() => {
                                                        setPrivacyChecked(!privacyChecked);
                                                    }}
                                                >
                                                    <span className="sr-only">
                                                        Datenschutzerklärung akzeptieren
                                                    </span>
                                                    <span
                                                        aria-hidden="true"
                                                        className={`${
                                                            !privacyChecked
                                                                ? 'translate-x-0'
                                                                : 'translate-x-5'
                                                        } inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out`}
                                                    />
                                                </button>
                                            </div>
                                            <div className="ml-3">
                                                <p className="text-base text-gray-500">
                                                    I hereby confirm that I have and that I have
                                                    read and accepted it:
                                                    <Link href="/page/privacy" passHref>
                                                        <button
                                                            type="button"
                                                            className="mx-1 font-medium text-gray-700 underline"
                                                        >
                                                            Privacy policy
                                                        </button>
                                                    </Link>
                                                    .
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="sm:col-span-2">
                                        <button
                                            type="button"
                                            onClick={() => {
                                                void submit();
                                            }}
                                            className="inline-flex w-full items-center justify-center rounded-md border border-transparent bg-secondary px-6 py-3 text-base font-medium text-white shadow-sm hover:bg-secondary focus:outline-none focus:ring-2 focus:ring-secondary focus:ring-offset-2"
                                        >
                                            <FontAwesomeIcon icon={faSmile} />
                                            <span className="mx-2">Let&apos;s talk</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    <div className="mt-14 transition-all">
                        <Link href="/" passHref>
                            <button
                                type="button"
                                className="button font-serif text-base text-primary"
                            >
                                back to blog<span aria-hidden="true">&nbsp;&rarr;</span>
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ContactForm;
